import React from 'react'
import {NatRejectionRegistrationApplyInfo} from '../roomToResident/repository/NatRejectionRegistrationApplyInfo';
import {RESIDENT_USER_REGISTRATION_APPLY_CATEGORY, ROLE_FOR_RESIDENT} from '../../../CodeMaster';
import {Messages} from '../../../Messages';


export function createRejectionResidentUserRegistrationApplyInfoMessage(
    rejectionRegistrationApplyInfoList: NatRejectionRegistrationApplyInfo[]): string {
    const rejectionResidentUserRegistrationApplyInfoListMessage: string[] = rejectionRegistrationApplyInfoList.map(
        (rejectionRegistrationApplyInfo) => {
            const applyCategoryLabel: string = RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.codeToEnumConstants(
                rejectionRegistrationApplyInfo.applyCategory).label
            const roleLabel: string = rejectionRegistrationApplyInfo.registrationRoleId !== null ?
                ROLE_FOR_RESIDENT.codeToEnumConstants(rejectionRegistrationApplyInfo.registrationRoleId).label : ' '
            return (
                Messages.IRESA0035.toString(
                    String(rejectionRegistrationApplyInfo.applyId),
                    applyCategoryLabel,
                    rejectionRegistrationApplyInfo.ridgeName,
                    rejectionRegistrationApplyInfo.ridgeCd,
                    rejectionRegistrationApplyInfo.roomNumber,
                    roleLabel
                )
            )
        })

    if (rejectionRegistrationApplyInfoList.length > 1) {
        return Messages.IRESA0034.toString() + '\n\n' +
            rejectionResidentUserRegistrationApplyInfoListMessage.join('\n')
    } else {
        return Messages.IRESA0033.toString() + '\n' +
            rejectionResidentUserRegistrationApplyInfoListMessage.join('\n')
    }
}
